import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter, map } from 'rxjs';

type BackgroundType = 'right-man-with-cellphone' | 'left-man-with-cellphone' | 'right-woman-with-cellphone' | 'smiling-woman' | 'type-2' | 'type-1';
type BackgroundClassName =
    | 'slide-right-bg-man-with-cellphone'
    | 'slide-right-bg-woman-with-cellphone'
    | 'slide-bg-smiling-woman'
    | 'background-2'
    | 'background-1'
    | 'left-bg-man-with-cellphone';

const BACKGROUND_CONFIG: Record<BackgroundType, BackgroundClassName> = {
    'right-man-with-cellphone': 'slide-right-bg-man-with-cellphone',
    'left-man-with-cellphone': 'left-bg-man-with-cellphone',
    'right-woman-with-cellphone': 'slide-right-bg-woman-with-cellphone',
    'smiling-woman': 'slide-bg-smiling-woman',
    'type-1': 'background-1',
    'type-2': 'background-2',
};

@Injectable({
    providedIn: 'root',
})
export class BackgroundService {
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly router = inject(Router);
    child?: ActivatedRoute;

    readonly setBackground$ = this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
            const child =
                this.router.routerState.root.children.length !== 0 ? this.getLastChild(this.router.routerState.root.children[0]) : this.activatedRoute;
            this.child = child;
            const background: BackgroundType | undefined = child.snapshot.data['background'];
            return { background, backgroundMobile: child.snapshot.data['backgroundMobile'] };
        }),
        filter((background) => {
            if (background.background !== undefined) {
                if (!this.isMobile) {
                    return true;
                } else {
                    if (background.backgroundMobile || background.backgroundMobile === undefined) {
                        return true;
                    }
                    return false;
                }
            }
            return false;
        }),

        map((background) => (background.background !== undefined ? BACKGROUND_CONFIG[background.background] : undefined) ?? ''),
    );

    get isMobile() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            return true;
        } else {
            return false;
        }
    }

    readonly removeBackground$ = this.router.events.pipe(
        filter((event) => event instanceof NavigationStart),
        map(() =>
            Array.from(document.body.classList).find((className): className is BackgroundClassName =>
                Object.values<string>(BACKGROUND_CONFIG).includes(className),
            ),
        ),
    );

    setWhiteBackgroundColor() {
        document.body.style.backgroundColor = 'white';
    }

    setGreyBackgroundColor() {
        document.body.style.backgroundColor = '#eff3f6';
    }

    private getLastChild(child: ActivatedRoute): ActivatedRoute {
        if (child.children.length === 0) {
            return child;
        }
        return this.getLastChild(child.children[0]);
    }
}
